@if ($agendamentos().length === 0) { @if (showEmptyState) {
<div class="n-empty-state">{{ 'BARDO_AGENDA.NOTIFICACAO.LISTA_VAZIA' | translate }}</div>
} } @else {
<p-dataview
  [value]="$agendamentos()"
  [rows]="numberRows"
  [paginator]="true"
  [emptyMessage]="'BARDO_AGENDA.NOTIFICACAO.NENHUM_ENCONTRADO' | translate"
  [totalRecords]="$agendamentos().length"
  [showCurrentPageReport]="true"
  [showPageLinks]="false"
  [showJumpToPageDropdown]="false"
  [showFirstLastIcon]="false"
  [currentPageReportTemplate]="'BARDO_AGENDA.NOTIFICACAO.PAGINACAO' | translate"
>
  <ng-template #list let-items>
    <div class="grid grid-cols-12 grid-nogutter gap-2">
      @for (item of items; track item.id) {
      <div
        class="n-card-mini n-notification-card shadow-1 surface-card overflow-hidden w-full n-card-hover n-pointer"
        (click)="acessarModalInformacao(item)"
        (keydown.enter)="acessarModalInformacao(item)"
        (keydown.space)="acessarModalInformacao(item)"
        role="button"
        tabindex="0"
      >
        <div class="n-badge n-amarelo">
          <span class="n-badge-date">{{
            formatarDataCurta(item.dataHora)
          }}</span>
          <span class="n-badge-time">{{ formatarHora(item.dataHora) }}</span>
        </div>

        <div class="n-card-info">
          <div class="n-row">
            <div class="n-info-group">
              <span class="n-info-primary nome-truncado">
                {{ item.cliente?.nome || item.nomeCliente }}
              </span>
              <span class="n-info-secondary nome-truncado">
                {{ formatarTelefone(item.cliente?.telefone || item.telefoneCliente) }}
              </span>
            </div>
            <div class="n-info-group">
              <span class="n-info-primary nome-truncado">
                {{ item.profissional?.nome }}
              </span>
              <span class="n-info-secondary nome-truncado">
                {{ item.servico?.nome }}
              </span>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </ng-template>
</p-dataview>
}
